import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { getStudentCertificates } from '../../../../../../services/apiService';

function Certificate({ goalType, userId }) {
  const [certificateData, setCertificateData] = useState(null);

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getStudentCertificates(goalType, userId);

        setCertificateData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [userId, goalType]);

  return (
    <div>
      <div className='ag-theme-alpine w-full'>
        <div className='grid gap-4 grid-cols-3'>
          {certificateData &&
            certificateData.map((certiItem, index) => (
              <div key={index}>
                <img
                  className='cursor-pointer'
                  src={certiItem.thumbnail}
                  onClick={() => {
                    window.open(certiItem.certificateUrl, '_blank').focus();
                  }}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Certificate;
